module.exports = "precision mediump float;\r\nvarying vec3 v_WorldPos;\r\nuniform float u_PoolHeight;\r\n\r\nvoid main(){\r\n\tvec4 worldPos = modelMatrix * vec4(position, 1.0);\r\n\tworldPos.y *= u_PoolHeight;\r\n\tgl_Position = projectionMatrix * viewMatrix * worldPos;\r\n\tv_WorldPos = worldPos.xyz;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/js/shader/cube/vertex.glsl
// module id = 17
// module chunks = 0